import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'For Providers',
    href: '#'
  }, {
    name: 'Healthcare Facilities',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Resources',
    href: '#'
  }];
  return <header style={{
    fontFamily: "'Poppins', sans-serif"
  }} className="absolute top-0 left-0 right-0 z-50" data-id="element-198">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-199">
        <div className="flex items-center justify-between h-24" data-id="element-200">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-201">
            <a href="#" data-id="element-202">
              <img src="https://allstarhealthcaresolutions.com/wp-content/uploads/2025/07/ALL-STAR_Logo_Light.svg" alt="All Star Healthcare Solutions" className="h-8.5 w-auto" style={{
              height: '34px'
            }} data-id="element-203" />
            </a>
          </div>

          {/* Desktop Navigation - aligned right */}
          <div className="hidden lg:flex items-center gap-2" data-id="element-204">
            <nav className="flex items-center" data-id="element-205">
              {navLinks.map(link => <a key={link.name} href={link.href} className="px-2.5 py-2 text-sm font-medium text-white transition-colors duration-200 hover:text-[#c75a4a]" style={{
              fontFamily: "'Poppins', sans-serif"
            }} data-id="element-206">
                  {link.name}
                </a>)}
            </nav>

            {/* Action Buttons */}
            <div className="flex items-center gap-3 ml-4" data-id="element-207">
              <Button variant="secondary" size="sm" className="!bg-[#3A5BA0] hover:!bg-[#2d4a8a] !border-transparent" data-id="element-208">
                Hire Providers
              </Button>
              <Button variant="primary" size="sm" className="!bg-[#780935] hover:!bg-[#5f072a] !border-transparent" data-id="element-209">
                Search Jobs
              </Button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden" data-id="element-210">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-white" data-id="element-211">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-212" /> : <Menu className="w-6 h-6" data-id="element-213" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-214">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white text-gray-900 absolute top-full left-0 right-0 shadow-xl border-t border-gray-100 overflow-hidden" data-id="element-215">
            <div className="px-4 pt-2 pb-8 space-y-1" data-id="element-216">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-4 text-lg font-medium border-b border-gray-100" style={{
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-217">
                  {link.name}
                </a>)}
              <div className="pt-6 px-3 flex flex-col gap-3" data-id="element-218">
                <Button variant="outline" className="w-full justify-center" data-id="element-219">
                  Hire Providers
                </Button>
                <Button variant="primary" className="w-full justify-center" data-id="element-220">
                  Search Jobs
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}